import { useEffect, useState } from "react";
import { api } from "./api";
import type { Gift } from "../data/presents";

let cache: Gift[] | null = null;
let pending: Promise<Gift[]> | null = null;
const listeners = new Set<(g: Gift[]) => void>();

export const loadGiftCatalog = () => {
  pending = pending || api.get<{ items: Gift[] }>("/gifts").then((r) => (cache = r.data.items)).catch((e) => { pending = null; throw e; });
  return pending;
};

export const resetGiftCatalog = () => {
  cache = null; pending = null;
  if (listeners.size) loadGiftCatalog().then((g) => listeners.forEach((l) => l(g))).catch(() => undefined);
};

export const affiliateHref = (id: string) => `${process.env.REACT_APP_BACKEND_URL}/api/go/${id}`;

const isInstalledApp = () => window.matchMedia?.("(display-mode: standalone)").matches || (navigator as any).standalone === true;

// Installed app: open shops in a pop-up window so closing it lands back in DITHER, not the browser's other tabs.
export const openShop = (e: { preventDefault: () => void }, href: string) => {
  if (!isInstalledApp()) return;
  e.preventDefault();
  const w = Math.min(1100, window.screen.availWidth - 40), h = Math.min(820, window.screen.availHeight - 60);
  const popup = window.open(href, "dither-shop", `popup,width=${w},height=${h}`);
  if (popup) { try { popup.opener = null; } catch { /* cross-origin already */ } } else window.open(href, "_blank", "noopener");
};

export function useGiftCatalog() {
  const [gifts, setGifts] = useState<Gift[] | null>(cache);
  const [error, setError] = useState(false);
  useEffect(() => {
    listeners.add(setGifts);
    if (!cache) loadGiftCatalog().then(setGifts).catch(() => setError(true));
    return () => { listeners.delete(setGifts); };
  }, []);
  return { gifts, error };
}
